<script>

import NumberFormat from "@/mixins/NumberFormat";
import VDataTableCustom from "@/components/VDataTable/VDataTableCustom.vue";
import _ from "lodash";

export default {
    name: "VDataTableWordCloudWords",
    components: {
        VDataTableCustom,
    },
    mixins: [NumberFormat],
    inheritAttrs: false,
    props: {
        limit: {
            type: Number,
        },
        items: {
            type: Array,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: '№ п/п',
                    align: 'start',
                    sortable: false,
                    width: 80,
                    value: 'index',
                    tooltip: 'Номер по порядку',
                },
                {
                    text: 'Слово',
                    align: 'start',
                    sortable: true,
                    value: 'text',
                    // filterComponent: 'VDataTableCustomHeaderFiltersText',
                },
                {
                    text: 'Значение',
                    align: 'right',
                    sortable: true,
                    value: 'value',
                    width: 120,
                    // filterComponent: 'VDataTableCustomHeaderFiltersText',
                },
            ],
            sort: {
                by: ['value'],
                desc: [true],
            },
        };
    },
    computed: {
        itemsWithIndex() {
            let index = 0;
            return _.map(this.items, (item) => {
                item.index = ++index;
                return item;
            });
        },
    },
    methods: {
        getItemClass(item) {
            return {
                empty: item?.value < 1,
                "non-effective": item?.num > this.limit,
                "scroll-margin": true,
                // на строку нет возможности повесить id, для прокрутки используется суррогатный идентификатор в виде класса
                ["wordcloud-word-id-" + item.id]: true,
            }
        }
    }
}
</script>

<template>
    <v-data-table-custom
        v-bind="$attrs"
        v-on="$listeners"
        :items="itemsWithIndex"
        :headers="headers"
        :sort-by="sort.by"
        :sort-desc="sort.desc"
        :item-class="getItemClass"
        item-key="id"
        permissions-by-module="wordclouds"
    >
        <template v-slot:item.index="{value}">
            {{ prettyInt(value) }}
        </template>
        <template v-slot:item.value="{value}">
            {{ prettyInt(value) }}
        </template>
        <template v-slot:top.append>
            <slot name="top.append"></slot>
        </template>
    </v-data-table-custom>
</template>

<style scoped lang="css">
>>> table tbody tr.empty td {
    color: silver;
    text-decoration: line-through;
}

>>> table tbody tr.non-effective td {
    color: silver;
}
/**
 * @TODO: возможно имеет смысл вынести в глобальный стиль .scroll-margin
 *   используется для прокрутки к элементу, что бы элемент был виден, а не располагался под header'ом, 64px высота header'а
 */
>>> table tbody tr.scroll-margin {
    scroll-margin: 64px;
}
</style>
